import { url } from "../link/Url.link";

export const EditUserInyect = ({editUser}) => {
  // console.log('editUser',editUser)
  return new Promise(async function(resolve, reject) {
    try {
      const query = await fetch(url+'/edituserinyect',{
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          editUser
        })
      })

        const reqkkst = await query.json();
        
        if(reqkkst.success){
          resolve(reqkkst.success)
          alert('datos actualizados con exito');
        }else{
          resolve(reqkkst.error)
          alert('Upss!! ocurrio un error vuelve a intentarlo');
        }
      } catch (error) {
        resolve(null)
      }
    

  })
}
